/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconStairs = createReactComponent("outline", "stairs", "IconStairs", [["path", { "d": "M22 5h-5v5h-5v5h-5v5h-5", "key": "svg-0" }]]);

export { IconStairs as default };
//# sourceMappingURL=IconStairs.mjs.map
